export default class ServiceManagerRoutes {
}

ServiceManagerRoutes.DUMMY_CALL = "dummy/call";
ServiceManagerRoutes.HELLO = "users/hello";
ServiceManagerRoutes.USER_DO_LOGIN = "users/doLogin";

